import axios from 'axios';
import { configure } from 'axios-hooks';

const API_URL =
  process.env.REACT_APP_BASE_API_URL || 'http://localhost:8080/api';

axios.defaults.baseURL = API_URL;
axios.defaults.headers.common['Content-Type'] = 'application/json';

axios.interceptors.request.use(
  (config) => {
    if (config.url?.includes('/refreshToken')) {
      const refreshToken = localStorage.getItem('refreshToken');
      if (refreshToken) {
        config.headers.Authorization = `Bearer ${refreshToken}`;
      }
    } else {
      const token = localStorage.getItem('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

configure({ axios });

export default axios;
